module.exports = __webpack_public_path__ + "img/tabicon_7.a73087b4.png";